<p-dialog
  [(visible)]="_visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '600px', 'max-width': '92vw' }"
  [contentStyle]="{ 'max-height': '65vh', 'overflow-y': 'auto' }"
  (onHide)="close()"
>
  <!-- Header -->
  <ng-template pTemplate="header">
    <div class="flex align-items-center gap-2">
      <i
        [class]="
          severity === 'error'
            ? 'pi pi-times-circle text-xl text-red-500'
            : 'pi pi-exclamation-triangle text-xl text-yellow-600'
        "
      ></i>
      <span
        class="font-semibold text-lg"
        [class]="severity === 'error' ? 'text-red-600' : 'text-yellow-700'"
      >
        {{
          severity === 'error'
            ? ('DATA.MODULES.CAMPAINGS.WORKFLOWS.VALIDATION_DIALOG.HEADER_ERROR' | translate)
            : ('DATA.MODULES.CAMPAINGS.WORKFLOWS.VALIDATION_DIALOG.HEADER_WARN' | translate)
        }}
      </span>
      <span class="ml-1 text-sm text-500">
        ({{ totalIssues }}
        {{
          totalIssues === 1
            ? ('DATA.MODULES.CAMPAINGS.WORKFLOWS.VALIDATION_DIALOG.ISSUE' | translate)
            : ('DATA.MODULES.CAMPAINGS.WORKFLOWS.VALIDATION_DIALOG.ISSUES' | translate)
        }})
      </span>
    </div>
  </ng-template>

  <!-- Body -->
  <div class="flex flex-column gap-4 pt-2">
    <!-- Workflow-level errors -->
    <div *ngIf="workflowErrors.length > 0">
      <div class="text-xs font-semibold text-500 uppercase letter-spacing-1 mb-2">
        {{ 'DATA.MODULES.CAMPAINGS.WORKFLOWS.VALIDATION_DIALOG.SECTION_WORKFLOW' | translate }}
      </div>
      <ul class="m-0 pl-3 flex flex-column gap-2">
        <li
          *ngFor="let err of workflowErrors"
          class="flex align-items-start gap-2 text-sm text-700"
        >
          <i
            [class]="
              severity === 'error'
                ? 'pi pi-times-circle text-red-400 mt-1'
                : 'pi pi-exclamation-circle text-yellow-500 mt-1'
            "
            style="font-size: 0.75rem; flex-shrink: 0"
          ></i>
          <span>{{ 'DATA.MODULES.CAMPAINGS.WORKFLOWS.VALIDATIONS.' + err | translate }}</span>
        </li>
      </ul>
    </div>

    <!-- Node-level errors grouped by node -->
    <div *ngIf="enrichedNodeGroups.length > 0">
      <div class="text-xs font-semibold text-500 uppercase letter-spacing-1 mb-2">
        {{ 'DATA.MODULES.CAMPAINGS.WORKFLOWS.VALIDATION_DIALOG.SECTION_NODES' | translate }}
      </div>
      <div class="flex flex-column gap-2">
        <div
          *ngFor="let group of enrichedNodeGroups"
          class="border-round-lg border-1 p-3"
          [class]="
            severity === 'error'
              ? 'border-red-200 bg-red-50'
              : 'border-yellow-200 bg-yellow-50'
          "
        >
          <!-- Node identity row -->
          <div class="flex align-items-center gap-2 mb-2">
            <span
              class="border-round px-2 py-1 text-xs font-semibold"
              [class]="
                severity === 'error'
                  ? 'bg-red-100 text-red-700'
                  : 'bg-yellow-100 text-yellow-800'
              "
            >
              {{ group.typeLabel }}
            </span>
          </div>

          <!-- Error list for this node -->
          <ul class="m-0 pl-3 flex flex-column gap-1">
            <li
              *ngFor="let msg of group.errors"
              class="flex align-items-start gap-2 text-sm text-700"
            >
              <i
                class="pi pi-arrow-right mt-1"
                style="font-size: 0.6rem; flex-shrink: 0"
              ></i>
              <span>{{ msg }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <ng-template pTemplate="footer">
    <div class="flex justify-content-end gap-2">
      <p-button
        [label]="'DATA.MODULES.CAMPAINGS.WORKFLOWS.VALIDATION_DIALOG.BTN_CLOSE' | translate"
        severity="secondary"
        [text]="true"
        (onClick)="close()"
      />
      <p-button
        *ngIf="severity === 'warn'"
        [label]="'DATA.MODULES.CAMPAINGS.WORKFLOWS.VALIDATION_DIALOG.BTN_SAVE_ANYWAY' | translate"
        severity="warning"
        icon="pi pi-save"
        (onClick)="onSaveAnyway()"
      />
    </div>
  </ng-template>
</p-dialog>